export default {
  misc: {
    showSnackbar: false,
    faqURL: "https://tournify.be/veelgestelde-vragen.html",
    generalTermsURL: "https://tournify.be/gebruiksvoorwaarden.html",
    liveURL: "https://tournifyapp.com/live/",
    finishedDescription3:
      "Heb je vragen? Stuur dan een mail naar info@tournify.be.",
  },
};
